module.exports = __webpack_public_path__ + "static/media/booking-badge.ba8bfb01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/booking-badge.svg
// module id = 266
// module chunks = 0